import { render, staticRenderFns } from "./ProjectDetailsModal.vue?vue&type=template&id=d26ef5e0&scoped=true&"
import script from "./ProjectDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsModal.vue?vue&type=style&index=0&id=d26ef5e0&lang=scss&"
import style1 from "./ProjectDetailsModal.vue?vue&type=style&index=1&id=d26ef5e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d26ef5e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d26ef5e0')) {
      api.createRecord('d26ef5e0', component.options)
    } else {
      api.reload('d26ef5e0', component.options)
    }
    module.hot.accept("./ProjectDetailsModal.vue?vue&type=template&id=d26ef5e0&scoped=true&", function () {
      api.rerender('d26ef5e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ProjectDetailsModal.vue"
export default component.exports